<template>
    <SettingsPage title="Site Completion">
        <template v-slot:settingsForms>
            <SettingsForm :settingsLoading="settingsLoading" form="completionForm">
                <template v-slot:form>
                    <form action="" method="POST" id="completionForm" @submit.prevent="saveCompletion" v-if="!settingsLoading && settings">
                        <v-text-field label="Button Text"
                                      name="siteCompletionButtonText"
                                      v-model="settings.siteCompletionButtonText"
                                      outlined
                        ></v-text-field>
                        <v-text-field label="Schedule URL"
                                      name="siteCompletionScheduleUrl"
                                      v-model="settings.siteCompletionScheduleUrl"
                                      outlined
                        ></v-text-field>
                        <v-text-field label="Schedule Notification Title"
                                      name="siteCompletionScheduleNotificationTitle"
                                      v-model="settings.siteCompletionScheduleNotificationTitle"
                                      outlined
                        ></v-text-field>
                        <v-textarea label="Schedule Notification Text"
                                    name="siteCompletionScheduleNotificationText"
                                    v-model="settings.siteCompletionScheduleNotificationText"
                                    outlined
                        ></v-textarea>
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

<script>
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';

export default {
    mixins: [ settingsMixin ],
    components: { SettingsForm, SettingsPage },
    props: [],

    data() {
        return {
            settingPage: 'siteCompletion',
            settingName: 'settingSiteCompletion',
        };
    },

    methods: {
        saveCompletion() {
            const settings = {
                siteCompletionButtonText: this.settings.siteCompletionButtonText,
                siteCompletionScheduleUrl: this.settings.siteCompletionScheduleUrl,
                siteCompletionScheduleNotificationTitle: this.settings.siteCompletionScheduleNotificationTitle,
                siteCompletionScheduleNotificationText: this.settings.siteCompletionScheduleNotificationText,
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}`, settings));
        }
    }
};
</script>
